import { IconType } from '@aibees/shared/components';
import { PaginationResponse, Workspace } from '@aibees/shared/definition';

export enum LabelType {
  LIST = 'LIST',
  LABEL = 'LABEL',
}

export enum LabelGrouping {
  COMPANY = 'COMPANY',
  PEOPLE = 'PERSON',
  ALL = 'COMPANY,PERSON',
}

export enum LabelVisibility {
  ALL = '',
  PRIVATE = 'PRIVATE',
  INTERNAL = 'INTERNAL',
}

export interface Label {
  id: string;
  created: string;
  modified: string;
  workspace: Workspace;
  description: string;
  color: string;
  icon: IconType;
  name: string;
  type: LabelType;
  grouping: LabelGrouping;
  records: number;
  status: string;
  visibility: LabelVisibility;
}

export type BrowseLabelsMetadata = Record<
  LabelGrouping | LabelVisibility,
  number
>;

export type BrowseMetadataResponse = PaginationResponse<
  Label,
  BrowseLabelsMetadata
>;

export interface CreateLabelRequest {
  type: LabelType;
  grouping?: LabelGrouping;
  name: string;
  description?: string;
  icon?: IconType;
  color?: string;
  ids?: string[];
  user?: Workspace['user'];
  visibility: LabelVisibility;
}

export interface EditLabelRequest {
  grouping?: LabelGrouping;
  name: string;
  description?: string;
  icon?: IconType;
  color?: string;
  visibility?: LabelVisibility;
}

export interface LabelColors {
  name: string;
  hexCode: string;
  value: string;
  selected: boolean;
}
